import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  inject
} from '@angular/core';
import { FlyoutLoggedInComponent } from '@com-delta-idp/mnx-capability-flyout-smart';
import { LoginHeaderComponent } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  AnalyticsDataPopulateService,
  SessionTimeOutWrapperComponent,
  removeModalOpen
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { PushPipe } from '@ngrx/component';
import { LoginWrapperHelperComponent } from './login-wrapper-helper.component';
@Component({
  selector: 'idp-login-wrapper',
  templateUrl: './login-wrapper.component.html',
  imports: [
    CommonModule,
    LoginHeaderComponent,
    PushPipe,
    FlyoutLoggedInComponent,
    SessionTimeOutWrapperComponent
  ],
  standalone: true,
  styleUrls: ['./login-wrapper.component.scss']
})
export class LoginWrapperComponent
  extends LoginWrapperHelperComponent
  implements OnInit
{
  @Input() shopHeader = false;
  @Input() isAlertAdvisory = false;
  @Output() triggerLogin = new EventEmitter<void>();
  analyticsService = inject(AnalyticsDataPopulateService);

  constructor(public el: ElementRef) {
    super();
    this.updateMobileDevice();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateMobileDevice();
  }

  private updateMobileDevice(): void {
    if (typeof window !== 'undefined') {
      const width = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );
      this.isMobileAndTabletDevice$.next(width < 992);
    }
  }

  ngOnInit(): void {
    this.loginFacadeService.loadHeaderFooter();
  }

  toggleModal(): void {
    this.loginFacadeService.updateToolTipToggle({
      displayLoginToolTip: false
    });
    this.triggerLogin.emit();
  }

  openFlyout(): void {
    this.flyoutToggle$.next(!this.flyoutToggle$.getValue());
    if (this.flyoutToggle$.getValue()) {
      this.loginFacadeService.updateToolTipToggle({
        displayAccountRecoveryToolTip: false
      });
    }
  }

  close(): void {
    this.flyoutToggle$.next(!this.flyoutToggle$.getValue());
    removeModalOpen();
  }

  onHeaderFlyoutTracking(element: HTMLElement): void {
    this.analyticsService.populateAnalyticsData(element);
  }

  analyticsEventTracking(element: HTMLElement): void {
    this.analyticsService.populateAnalyticsData(
      element,
      undefined,
      undefined,
      true
    );
  }
}
